import Search from './search'
import * as Device from './device'


export function createSearch(base: string) {
  return new Search(base, numSuggestionsToFetch())
}


function numSuggestionsToFetch() {
  const width = Device.getWidth()
  const height = Device.getHeight()

  // line-height: 1.8

  if (width > 900) {
    // height = 1.8 * 26 = 47
    return Math.floor((height - 80)/47) - 1

  } else if (width > 600) {
    // 80 pixel header extra
    // height = 1.8 * 26 = 47
    return Math.floor((height - 160)/47) - 1

  } else {
    // height = 1.8 * 22 = 40
    const n = Math.floor((height - 160)/40) - 1
    // NOTE: Android Chrome subtracts the keyboard height, thus giving you
    // too few results.
    return Math.max(n, 8)
  }
}


// WEBPACK FOOTER //
// ./src/service/suggester.ts